/* eslint-disable */
import { useEffect, useState } from 'react';
import { ExternalLink, Plus } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import Info from '@/Components/InfoTab/Info';
import Tab from '@/Components/InfoTab/tab';
import GrnHeader from '@/Pages/GRNPage/grnHeader';
import { analyticsAction, modalActions } from '@/Actions';
import CreateShipmentModal from '../Shipment/createShipmentModal';
import GrnTable from '@/Pages/GRNPage/GrnTable';
import {
	addCommas, baseUnits, capitalizeFirstLetter, getPODeltas, getUnitConvertedQuantity, getUnitConvertedUnit, handleOrderStatus, renderSalesWeightQty, renderSalesWeightUnit, inputHelper, keyPressHandler, useQuery
} from '@/Helpers';
import { urls } from '@/Constants';
import useKeyPress from '@/Helpers/useKeyPress';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import assetServices from '@/Services/AssetServices/asset.services';
import DocumentsImagesSection from './DocumnetSection';
import { Visibility } from '@mui/icons-material';
import { TransactionsModal } from '@/Components/Modals/TransactionsModal';
import { POItemsModal } from '@/Components/Modals/POItemsModal';
import { DocumentModal } from './docModal';
import { AlertModal } from '@/Components/Modals';
import { notificationServices } from '@/Services';

const tabList = [
	{
		label: 'Ordered Products',
		value: 'orderedProducts',
	},
	{
		label: 'Shipments',
		value: 'shipment',
	},
	{
		label: 'Debit/Credit Notes',
		value: 'debitCreditNote',
	},
	// {
	// 	label: 'View Assets',
	// 	value: 'assets',
	// },
	{
		label: 'Documents',
		value: 'documents',
	},
];

const fieldsMap = {
	'Client Po': 'clientPoId',
	'Delivery From': 'deliveryFrom',
	'Delivery To': 'deliveryTo',
	Shipment: 'shipments',
	'PO Type': 'poType',
	'Order Date': 'orderDate',
	'Scheduled Date': 'scheduledAt',
	'Created By': 'createdBy',
	'Order Value': 'orderValue',
	'Extra Charges + Delivery Charges': 'shipmemtAmount',
};
function StoreSalesDetails() {
	const search = useQuery();
	const history = useHistory();
	const location = useLocation();
	const poId = Number(search.get('poId'));
	const clientPoId = search.get('clientPoId');
	const poList = useSelector((state) => state?.analytics?.INVENTORY_ANALYTICS?.PO_LIST);
	const poData = poList.find((item) => item?.id === poId);
	const keyPressed = useKeyPress();
	const [tabValue, setTabValue] = useState('');
	const [po, setPo] = useState({});
	const [data, setData] = useState([]);
	const [idx, setIdx] = useState(-1);
	const [poInfo, setPoInfo] = useState({});
	const [shipmentList, setShipmentList] = useState({});
	const dispatch = useDispatch();
	const formatDate = (date) => (date ? moment(date).format('Do MMMM YY') : 'N/A');
	const backUrl = history?.location?.state?.prevPath || urls.EXTENSION + urls.PO_LIST_NEW;

	const fetchShipmentsList = async () => {
		try {
			const response = await inventoryAnalyticsServices?.Shipmentlist({
				req: {
					data: {
						calculateWorth: true,
						filters: {
							poId: Number(poId),
						},
					},
				}
			});

			if (response?.statusCode === 200) {
				setShipmentList({
					total: response?.total || 0,
					data: response?.data || [],
				});
			}
		} catch (error) {
			console.error('Error fetching shipment list:', error);
		}
	};

	useEffect(() => {
		setPo(poData);
		fetchShipmentsList();
	}, [poId]);

	const handleShipmentAmount = () => {
		if (!shipmentList?.data?.length) return 0;

		const total = shipmentList.data.reduce((acc, shipment) => {
			const deliveryCharge = shipment.deliveryCharges || 0;
			const deliveryTax = (deliveryCharge * (shipment.deliveryTaxPercentage || 0)) / 100;

			const packagingCharge = shipment.packagingCharges || 0;
			const packagingTax = (packagingCharge * (shipment.packagingTaxPercentage || 0)) / 100;

			const additionalCharges =
				shipment.extraData?.[0]?.jsonData?.additionalCharges || [];

			const additionalChargeTotal = additionalCharges.reduce((sum, charge) => {
				const price = charge?.price || 0;
				return sum + price;
			}, 0);

			return (
				acc +
				deliveryTax +
				packagingTax +
				additionalChargeTotal
			);
		}, 0);

		return total.toFixed(2);
	};


	const fetchpo = async () => {
		try {
			const response = await inventoryAnalyticsServices.fetchPo(poId);
			if (response?.statusCode === 200) {
				return response?.data;
			}
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(async () => {
		if (!po) {
			const updatedPo = await fetchpo();
			setPo(updatedPo);
			setTabValue('orderedProducts');
			setData(updatedPo?.items || []);
			setPoInfo({
				id: updatedPo?.id,
				clientPoId: updatedPo?.clientPoId,
				deliveryFrom: updatedPo?.fromStoreName || 'N/A',
				deliveryTo: updatedPo?.storeName || 'N/A',
				shipments: shipmentList?.total ?? 'N/A',
				createdBy: updatedPo?.initiatedByName || 'N/A',
				orderValue: updatedPo,
				orderDate: formatDate(updatedPo?.createdAt),
				scheduledAt: formatDate(moment(updatedPo?.scheduledAt, ['DD/MM/YYYY', moment.ISO_8601]).isValid() ? moment(updatedPo?.scheduledAt, ['DD/MM/YYYY', moment.ISO_8601]) : null),
				poType: updatedPo,
				shipmemtAmount: handleShipmentAmount(),
			});
			return;
		};
		setTabValue('orderedProducts');
		setData(po?.items || []);
		setPoInfo({
			id: po?.id,
			clientPoId: po?.clientPoId,
			deliveryFrom: po?.fromStoreName || 'N/A',
			deliveryTo: po?.storeName || 'N/A',
			shipments: shipmentList?.total ?? 'N/A',
			createdBy: po?.initiatedByName || 'N/A',
			orderValue: po,
			orderDate: formatDate(po?.createdAt),
			scheduledAt: formatDate(po?.scheduledAt),
			poType: po,
			shipmemtAmount: handleShipmentAmount(),
		});
	}, [po, shipmentList]);

	const handleViewDoc = (document, documents) => {
		dispatch(modalActions?.toggleDocumentModal(true, { obj: document, list: documents }));
	};

	const handleListFetch = async () => {
		try {
			const responseData =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							filters: {
								orderId: poId,
							},
							type: 'CREDIT',
							transactionItems: true,
						},
					},
				});
			if (responseData?.statusCode === 200) {
				setData(responseData?.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleAssetFetch = async () => {
		try {
			const res = await assetServices?.fetchAssetTransitFlow({
				req: {
					params: {
						id: Number(poId),
					},
				},
			});
			if (res?.statusCode === 200) {
				const response = res?.data;
				setData(response);
				return;
			}
		} catch (error) {
			console.log(error);
		}
	}
	const afterShipmentSave = async () => {
		const updatedPo = await fetchpo();
		setPo(updatedPo);
		fetchShipmentsList();
	}

	const handleDocData = async () => {
		let docData = [];
		try {
			const response = await inventoryAnalyticsServices.fetchPoPdfDoc({
				req: {
					params: {
						orderId: poId,
					},
				},
			});
			if (response?.statusCode === 200) {
				const docObj = {
					name: `PO_${poId}_${clientPoId}`,
					type: 'pdf',
					uploadedDate: po?.createdAt,
					base64url: response?.data?.base64,
					url: po?.poURL,
				};
				docData.push(docObj);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
		setData(docData);
	};

	const handleTabChange = (value) => {
		setTabValue(value);
		if (value === 'debitCreditNote') {
			handleListFetch();
		} else if (value === 'orderedProducts') {
			setData(po?.items);
		} else if (value === 'assets') {
			handleAssetFetch();
		} else if (value === 'documents') {
			handleDocData();
		}
	};

	const handleButtons = () => {
		return buttons?.filter((item) => {
			const status = po?.orderStatus;
			const shipmentCount = shipmentList?.data?.length || 0;
			if ((shipmentCount === 0 || status === 'CANCELLED' || status === 'ABANDONED' || status === 'CLOSED') && item?.label === 'Close PO') {
				return false;
			}
			if (status === 'DISPATCH' && item?.label === 'Cancel') {
				return false;
			}
			if (status === 'PENDING' && item?.label === 'Reopen') {
				return false;
			}
			return true;
		});
	};

	const openShipmentModal = () => {
		dispatch(modalActions.toggleCreateShipmentModal(true, po));
	};

	const handlePoStatus = (id, status) => {
		// eslint-disable-next-line no-console
		const statusText = status === 'CANCEL' ? 'Cancelling' : status === 'REOPEN' ? 'Re-opening' : 'Closing';
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `${statusText}  Po ${id || ''}`,
			});
			try {
				const resp = await inventoryAnalyticsServices.changeOrderStatus(
					{
						params: {
							poId: id,
							status,
							...(status === 'CLOSE' && { forceCancelShipment: true }),
						},
					}
				);
				notificationServices.generateNotification({
					type: 'success',
					message: resp?.status,
					config: {
						id: notificationId,
					},
				});
				const updatedPo = await fetchpo();
				setPo(updatedPo);
				dispatch(modalActions?.toggleAlert(false));
				dispatch(analyticsAction.updatePOList(idx, updatedPo));
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	const handleReopen = () => {
		dispatch(modalActions?.toggleAlert(true, {
			heading: 'Re-Open PO',
			handleConfirm: () => {
				handlePoStatus(poId, 'REOPEN');
			},
			colorReverse: true,
			cancelText: 'No',
			confirmText: 'Yes',
			message: `Are you sure you to re-open po-${poId || ''
				}?`,
		}));
	};

	const handleCancel = (type = 'CANCEL') => {
		dispatch(modalActions?.toggleAlert(true, {
			heading: type === 'CANCEL' ? 'Cancel PO' : 'Close PO',
			handleConfirm: () => {
				handlePoStatus(poId, type);
			},
			colorReverse: false,
			cancelText: 'No',
			confirmText: 'Yes',
			message: `Are you sure you to ${type === 'CANCEL' ? 'cancel' : 'close'} ${poId || ''
				}?`,
		}));
	};

	const buttons = [
		{
			label: 'Reopen',
			handleClick: handleReopen,
			style: 'bg-slate-100',
		},
		{
			label: 'Close PO',
			handleClick: () => handleCancel('CLOSE'),
			style: 'border-red-700 text-red-700',
		},
		{
			label: 'Cancel',
			handleClick: () => handleCancel('CANCEL'),
			style: 'text-red-700 border-red-700',
		},
		{
			label: 'Add Shipment',
			icon: <Plus size={16} />,
			handleClick: openShipmentModal,
			style: 'bg-yellow-500',
			disabled: true,
		},
	];

	useEffect(() => {
		if (poList?.length > 0) {
			const currentIndex = poList.findIndex(
				(item) => item.id === poId
			);
			setIdx(currentIndex);
		}
	}, [poId, poList]);

	const navigateQc = (e) => {
		const { dataset } = inputHelper(e);
		let newListItem = null;

		if (dataset.type === 'next') {
			newListItem = poList?.[idx + 1];
		} else {
			newListItem = poList?.[idx - 1];
		}

		if (newListItem) {
			history.push({
				pathname: `${urls.EXTENSION}${urls.STORE_SALES_DETAILS}`,
				search: `poId=${newListItem?.id}&clientPoId=${newListItem?.clientPoId}`,
				state: {
					prevPath: backUrl,
				},
			});
		}
	};

	useEffect(() => {
		const qcData = poList?.[idx] ?? null;
		if (
			(keyPressed === 'ArrowLeft' || keyPressed === 'ArrowRight') &&
			qcData !== null
		) {
			const newListItem = keyPressHandler(
				keyPressed,
				poList,
				idx
			);
			if (newListItem) {
				history.push({
					pathname: `${urls.EXTENSION}${urls.STORE_SALES_DETAILS}`,
					search: `poId=${newListItem?.id}&clientPoId=${newListItem?.clientPoId}`,
					state: {
						prevPath: backUrl,
					},
				});
			}
		}
	}, [keyPressed]);


	const handleAppliedOnBills = async (credItem) => {
		try {
			const response =
				await inventoryAnalyticsServices.getTransactionRecord({
					params: {
						transactionId: credItem?.id,
						type: 'CREDIT',
					},
				});
			if (response?.statusCode === 200) {
				dispatch(modalActions?.toggleTransactionsModal(true, {
					listData: response?.data?.PAYMENTS?.map((ele) => {
						return {
							...ele,
							creditUsedAmount: ele?.txnUsedAmount,
						};
					}),
					transactionType: 'PAYMENTS',
					heading: `${response?.data?.clientTransactionId ??
						response?.data?.id
						}- Debit Applied on Payments`,
				}));
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleViewClick = (item) => {
		const noteType = item?.subType?.split('_')?.join(' ');
		dispatch(modalActions?.togglePOItemsModal(true, {
			width: '90%',
			height: '90%',
			heading: `${capitalizeFirstLetter(noteType)} of #${item?.clientInvoiceId ?? item?.id
				}`,
			...item,
			transactionData: {
				'Client ID': item?.clientTransactionId ?? '-',
				'Order ID': item?.orderId,
				'Vendor Name': item?.vendorName ?? '',
				Store: item?.storeName,
				[`${capitalizeFirstLetter(noteType)} Date`]: moment(
					item?.createdAt
				).format('YYYY-MM-DD'),
				[`${capitalizeFirstLetter(noteType)} Amount`]:
					item?.finalTransactionAmount,
			},
			excludedColumns: [
				'Packaged',
				'Ordered Quantity',
				'Dispatched',
				'Received',
				'Returned Quantity',
				'Fulfilled',
				'From Process',
				'PO Id',
				'Returned',
				'Production Plan Name',
				'Used For',
				'Last Purchase Rate 1',
				'Last Purchase Rate 2',
				'Last Purchase Rate 3',
				'Recommended Quantity',
			],
		}));
	};

	//  orderProducts Tab
	const colMapOrderProducts = {
		'Variant Name': 'id',
		Unit: 'unit',
		'PO Quantity': 'qty',
		Packaged: 'packaged',
		Dispatched: 'fulfilled',
		Received: 'storeFulfilled',
		'Item Price': 'id',
		'Discount %': 'id',
		'Tax %': 'id',
		'Tax Value': 'id',
		'Total Amount': 'id',
	};

	const SPECIAL_COLUMNS = [
		{
			title: 'Variant Name',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Unit',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'PO Quantity',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Packaged',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Dispatched',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Received',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Item Price',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Discount %',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Tax %',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Tax Value',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Total Amount',
			config: {
				type: 'DATA',
			},
		},
	];

	const orderSpecialMapping = {
		'Variant Name': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return (
				<div className='text-left '>
					<span className='text-[12px] text-nowrap'>
						{item?.productName +
							(item?.variantName
								? ` (${item?.variantName})`
								: '')}
					</span>
					<span className='text-[12px]'>{item?.description ? item?.description : ''}</span>
				</div>
			);
		},
		Unit: (itemId, value) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const salesWeight = renderSalesWeightUnit(item);
			if (salesWeight) return salesWeight;
			const itemUnit = item?.unit;
			if (baseUnits?.includes(itemUnit)) {
				return getUnitConvertedUnit(item?.qty, itemUnit);
			}
			return <span className='text-[12px] text-left'>{itemUnit}</span>;
		},
		'Tax Value': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			let itemQty = item?.qty;
			if (baseUnits?.includes(item?.unit)) {
				itemQty = getUnitConvertedUnit(itemQty, item?.unit);
			}
			let itemPrice = item?.price;
			if (item?.unit === 'gram' || item?.unit === 'ml') {
				itemPrice /= 1000;
			}
			if (item?.unit === 'oz') {
				itemPrice /= 16;
			}
			if (item?.unit === 'floz') {
				itemPrice /= 128;
			}
			const percentageValue =
				(itemPrice * itemQty * item?.taxPercentage) / 100;
			if (!item?.productTaxValue) {
				return <span className='text-[12px] text-left'>₹{addCommas(percentageValue)}</span>;
			}
			return <span className='text-[12px] text-left'>{`₹${addCommas(item?.productTaxValue)}` ?? '-'}</span>;
		},
		'PO Quantity': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemQty = item?.qty;
			const salesWeight = renderSalesWeightQty(item, itemQty);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemQty,
					item?.unit,
					true,
					true
				);
			}
			return <span className='text-[12px] text-left'>{itemQty}</span>;
		},
		Packaged: (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemPacked = item?.packaged;
			const salesWeight = renderSalesWeightQty(item, itemPacked);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemPacked,
					item?.unit,
					true,
					true
				);
			}
			return <span className='text-[12px] text-left'>{itemPacked}</span>;
		},
		Received: (itemId) => {
			const item = data?.find?.((poItem) => {
				return itemId === poItem?.id;
			});
			const itemReceived = item?.storeFulfilled;
			const salesWeight = renderSalesWeightQty(item, itemReceived);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemReceived,
					item?.unit,
					true,
					true
				);
			}
			return <span className='text-[12px] text-left'>{itemReceived}</span>;
		},
		Dispatched: (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			const itemFulfilled = item?.fulfilled;
			const salesWeight = renderSalesWeightQty(item, itemFulfilled);
			if (salesWeight) return salesWeight;
			if (baseUnits?.includes(item?.unit)) {
				return getUnitConvertedQuantity(
					itemFulfilled,
					item?.unit,
					true,
					true
				);
			}
			return <span className='text-[12px] text-left'>{itemFulfilled}</span>;
		},
		'Total Amount': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return (
				<span className='text-[12px] text-left'>{`₹${addCommas(item?.totalValue ?? item?.finalAmount)}` ?? '-'}</span>
			);
		},
		'Item Price': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return <span className='text-[12px] text-left'>₹{item?.productCost ?? item?.price ?? '-'}</span>;
		},
		'Discount %': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return <span className='text-[12px] text-left'>{item?.discountPercentage ?? '-'}</span>;
		},
		'Tax %': (itemId) => {
			const item = data?.find((poItem) => {
				return itemId === poItem?.id;
			});
			return <span className='text-[12px] text-left'>{`${item?.taxPercentage}%` ?? '-'}</span>;
		},
	};

	const infoSpecialFeild = {
		'PO Type': (id, item) => {
			const generationType = item?.jsonData?.deltaType;
			if (!generationType) return <p className='text-[14px] font-semibold'>Regular</p>;
			if (generationType === 'UNDER_RECEIVING') {
				return (
					<p className='text-red-700 text-[14px] '>
						Under Reciving
					</p>
				);
			}
			if (generationType === 'EXCESS_RECEIVING') {
				return (
					<p className='text-red-700 text-[14px]'>
						Excess Reciving
					</p>
				);
			}
		},
		'Order Value': (id, item) => {
			const orderAmount =
				item?.finalValue == 0 ? item?.orderValue : item?.finalValue;
			return (
				<p className='text-[14px] font-semibold'>
					₹
					{orderAmount >= 0 ? addCommas(orderAmount) : '-'}
					{getPODeltas(item)}
				</p>
			);
		},
	};
	// debit credit note
	const debitColMap = {
		Type: 'subType',
		'Debit/Credit Note Date': 'transactionDate',
		Status: 'transactionStatus',
		'Total Amount': 'finalTransactionAmount',
		'Balance Amount': 'currentAmount',
		'View Applied On': 'id',
	};

	const debitColumn = [
		{
			title: 'Type',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Debit/Credit Note Date',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Status',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Total Amount',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Balance Amount',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'View Applied On',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'View',
			config: {
				type: 'DATA',
			},
		},
	];

	const specialDebitNote = {
		'Type': (id, items) => {
			return <span className='text-[12px] text-left'>{items}</span>;
		},
		'Debit/Credit Note Date': (id, items) => {
			return <span className='text-[12px] text-left'>{items}</span>;
		},
		'Status': (id, items) => {
			return <span className='text-[12px] text-left'>{items}</span>;
		},
		'Total Amount': (id, items) => {
			return <span className='text-[12px] text-left'>{items}</span>;
		},
		'Balance Amount': (id, items) => {
			return <span className='text-[12px] text-left'>{items}</span>;
		},
		'View Applied On': (id, items) => {
			const credItem = data?.find((ele) => {
				return id === ele?.id;
			});
			return (
				<Visibility
					className='w-[19px] h-[19px] cursor-pointer hover:text-[#4a70fb]'
					onClick={() => {
						handleAppliedOnBills(credItem);
					}}
				/>
			);
		},
	};

	// asset
	const assetColumns = [
		{
			title: 'Assets',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Count',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Packging',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Dispatch',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Reciving',
			config: {
				type: 'DATA',
			},
		},
	];

	const assetSpecialColumn = {
		Assets: 'qrCode',
		Count: 'qrCount',
		Packging: 'packaged',
		Dispatch: 'scannedForDispatch',
		Reciving: 'scannedAtStore',
	};
	const assetSpecialFeilds = {
		Assets: (_, item) => {
			return <span className='text-[12px] text-left'>{item}</span>;
		},
		Count: (_, item) => {
			return <span className='text-[12px] text-left'>{item}</span>;
		},
		Packging: (_, item) => {
			return item ? <DoneIcon className='text-green-600' /> : <CloseIcon className='text-red-600' />
		},
		Dispatch: (_, item) => {
			return item ? <DoneIcon className='text-green-600' /> : <CloseIcon className='text-red-600' />
		},
		Reciving: (_, item) => {
			return item ? <DoneIcon className='text-green-600' /> : <CloseIcon className='text-red-600' />
		},
	};

	// shipment Tab
	const shipmentColumns = [
		{
			title: 'Shipment Id',
			config: { type: 'DATA' },
		},
		{
			title: 'Dispatch Date',
			config: { type: 'DATA' },
		},
		{
			title: 'Receiving Date',
			config: { type: 'DATA' },
		},
		{
			title: 'Shipment Type',
			config: { type: 'DATA' },
		},
		{
			title: 'Vehicle Number',
			config: { type: 'DATA' },
		},
		{
			title: 'Delivery Charges',
			config: { type: 'DATA' },
		},
		{
			title: 'Total Amount',
			config: { type: 'DATA' },
		},
		{
			title: 'Status',
			config: { type: 'DATA' },
		},
		{
			title: '.',
			config: {
				type: 'DATA',
			},
		}
	];

	// shipment colMap
	const shipmentColMap = {
		'Shipment Id': 'id',
		'Dispatch Date': 'sendingDate',
		'Receiving Date': 'receivingDate',
		'Shipment Type': 'shipmentType',
		'Vehicle Number': 'transVehicleNo',
		'Delivery Charges': 'deliveryCharges',
		'Total Amount': 'qtyValue',
		'Status': 'status',
	};

	// shipment specialMappings
	const shipmentSpecialMappings = {
		'Shipment Id': (id, items) => {
			return <p className='text-[12px] text-left'>{items}</p>;
		},
		'Dispatch Date': (id, items) => {
			return <p className='text-[12px] text-left'>{items}</p>;
		},
		'Receiving Date': (id, items) => {
			return <p className='text-[12px] text-left'>{items}</p>;
		},
		'Shipment Type': (id, items) => {
			return <p className='text-[12px] text-left'>{items}</p>;
		},
		'Vehicle Number': (id, items) => {
			return <p className='text-[12px] text-left'>{items}</p>;
		},
		'Status': (id, items) => {
			return <p className='text-[12px] text-left'>{items}</p>;
		},
		'Delivery Charges': (id, items) => {
			return <p className='text-[12px] text-left'>{items}</p>;
		},
		'Total Amount': (id, items, row) => {
			const shipment = shipmentList?.data?.find((ele) => ele?.id == id);
			const chargesAndWorth = shipment?.chargesAndWorth;
			const totalValue = chargesAndWorth?.sendingQty?.totalShipment_sendingQty_Value;
			// return <p className='text-[12px] text-left'>{items.toFixed(2)}</p>;
			return <p className='text-[12px] text-left'>{(totalValue || 0).toFixed(2)}</p>;
		},
		'.': (id, items) => {
			return <ExternalLink size={16} className='text-[12px] text-left cursor-pointer hover:text-[#4a70fb]' onClick={() => {
				history.push({
					pathname: `${urls.EXTENSION}${urls.SHIPMENT_DETAILS}`,
					search: `?id=${id}`,
					state: {
						prevPath: location.pathname + location.search,
					},
				});
			}} />;
		},
	};

	return (
		<>
			<CreateShipmentModal
				fetchPo={afterShipmentSave}
			/>
			<TransactionsModal />
			<POItemsModal />
			<AlertModal />
			<DocumentModal />
			<GrnHeader
				title='Back to Internal Sales Orders'
				navigateLabel='Refence PO ID'
				id={poId}
				navigatePrevToolTip='Prev Po'
				navigateNextToolTip='next Po'
				navigateQC={navigateQc}
				listData={poList}
				idx={idx}
				url={backUrl}
			/>
			<div className='relative top-[3rem] p-4'>
				<Info
					buttons={handleButtons()}
					fieldMap={fieldsMap}
					data={poInfo}
					specialFields={infoSpecialFeild}
					heading={
						{
							key: 'PO Status',
							value: handleOrderStatus(po?.orderStatus),
						}
					}
				/>
				<Tab
					tabList={tabList}
					tabValue={tabValue}
					handleTabChange={handleTabChange}
				/>
				{tabValue === 'orderedProducts' && (
					<GrnTable
						data={data}
						colMap={colMapOrderProducts}
						special={SPECIAL_COLUMNS}
						specialMappings={orderSpecialMapping}
						tableType='orderedProducts'
					/>
				)}
				{tabValue === 'shipment' && (
					<GrnTable
						data={shipmentList?.data}
						colMap={shipmentColMap}
						special={shipmentColumns}
						specialMappings={shipmentSpecialMappings}
						tableType='shipment'
					/>
				)}
				{tabValue === 'assets' && (
					<GrnTable
						data={data}
						colMap={assetSpecialColumn}
						special={assetColumns}
						specialMappings={assetSpecialFeilds}
						tableType='assets'
					/>
				)}
				{tabValue === 'debitCreditNote' && (
					<GrnTable
						data={data}
						colMap={debitColMap}
						special={debitColumn}
						specialMappings={specialDebitNote}
						handleViewClick={handleViewClick}
						tableType='debitCreditNote'

					/>
				)}
				{tabValue === 'documents' && (
					<DocumentsImagesSection
						documents={data}
						handlePreview={handleViewDoc}
					/>
				)}
			</div>
		</>
	);
}

export default StoreSalesDetails;
